import React, { useEffect, useState } from 'react'

import {
  Box,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { Copy as CopyIcon } from 'react-feather'

import { BaseDialog, LoadingFeedback } from 'components'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from './styles'

const ExternalLinkDialog = ({ open, setOpen }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [config, setConfig] = useState(null)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const { MODULES } = constants.companyGuestPortalConfig

  const portalLink = config?.token
    ? helpers.companySuppliers.buildSupplierJourneyUrl(
        config.token,
        config.organizationSlug,
      )
    : ''

  const loadData = async () => {
    setIsLoading(true)

    try {
      const response = await service.dponet.companyGuestPortalConfig.show(
        MODULES.COMPANY_SUPPLIER,
      )

      setConfig(response?.data?.companyGuestPortalConfig)
    } catch (error) {
      setConfig(null)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Não foi possível carregar o link externo.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleCopyLink = () => {
    if (!portalLink) return

    navigator.clipboard.writeText(portalLink)
    snackbar.open({ message: 'Link copiado!', variant: 'success' })
  }

  useEffect(() => {
    if (open) loadData()
    // eslint-disable-next-line
  }, [open])

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <BaseDialog
        open={open}
        setOpen={setOpen}
        title="Auditoria de Fornecedores"
        closeButtonText="Fechar"
        dialogSize="sm"
        fullWidth
      >
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography variant="body2" className={classes.explanationText}>
              Este é o link exclusivo do portal de fornecedores da sua
              organização. Envie-o para seus fornecedores, ao acessá-lo, cada
              fornecedor poderá se identificar e responder o questionário de
              auditoria de forma independente. Atenção! Não se esqueça de
              cadastrá-lo antes.
            </Typography>

            <TextField
              value={portalLink}
              fullWidth
              variant="outlined"
              margin="normal"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Copiar link">
                      <IconButton
                        size="small"
                        onClick={handleCopyLink}
                        disabled={!portalLink}
                      >
                        <CopyIcon size={16} />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </>
        )}
      </BaseDialog>
    </>
  )
}

export default ExternalLinkDialog
